import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import { Card, CardBody, Row, Col, Label, Button, Alert } from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import {
  fetchCrearCarritoAP,
  fetchRecuperarCarritoAP,
  fetchListarProvinciasAP,
  fetchListarCiudadesAP
} from "../../redux/actions/aRamoAccidentesPersonales";
import LoadingScreen from "react-loading-screen";
import makeAnimated from "react-select/lib/animated";
import Select from "react-select";
import { Select as Select1 } from "react-inputs-validation";
import { Textbox, Textarea } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import { ambienteAplicacion } from "../../constants/urls";
import {sucursalesFetch } from "../../redux/actions/aRamos";
import { EquiRamos, ErrorMsgConstants } from "../../constants";
import { isDuplicateHogar } from "../../redux/actions/ACarritoProductos";

class CotizacionAPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      empresa: "",
      solicitante: "",
      ruc: "",
      cedula: "",
      idCarrito: "",
      hasEmpresaError: true,
      hasSolicitanteError: true,
      hasRucError: true,
      hasCedulaError: true,
      hasDireccionError: true,
      idAsesor: "",
      sucursalSeleccionada: "",
      loadingPaso: false,
      hasProvinciaError: true,
      hasCiudadError: true,
      hasSucursalError:true,
      provinciaSelected: "",
      ciudadSelected: "",
      arrayProvincias: [],
      arrayCiudades: [],
      direccionSelected: "",
      cargandoCiudades: false
    };

    this.validateForm = this.validateForm.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e) {
    const {
      cedula,
      ruc,
      empresa,
      solicitante,
      idCarrito,
      validate,
      loadingPaso,
      hasDireccionError,
      hasCiudadError,
      hasSucursalError,
      sucursalSeleccionada,
      direccionSelected,
      ciudadSelected
    } = this.state;

    e.preventDefault();
    this.toggleValidating(true);

    // Llamar al servicio de validación de duplicidad de poliza
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",        
      plataforma: 'WEB',
      identificacion: ruc,
      ramo: EquiRamos.travel,
    };
    console.log('checkDuplicidadObj pymes', checkDuplicidadObj, );
    await this.props.checkIsDuplicate({type:'otros', postObj:checkDuplicidadObj});

    const {
      hasEmpresaError,
      hasSolicitanteError,
      hasRucError,
      hasCedulaError
    } = this.state;
    // si es que no existe duplicidad, continuar al siguiente paso
    if (!this.props.duplicity.isDuplicatePoliza){
      // continuar si no hubo errores
      if (
        !hasEmpresaError &&
        !hasSolicitanteError &&
        !hasRucError &&
        !hasDireccionError &&
        !hasCiudadError &&
        !hasSucursalError &&
        // servicio duplicidad funciono correctamente
        !this.props.duplicity.duplicidadPolizaError &&
        /*  !hasCedulaError 
        && */
        solicitante !== "" &&
        empresa !== "" &&
        direccionSelected !== "" &&
        ciudadSelected !== "" &&
        sucursalSeleccionada !=="" &&
        /*  cedula!==''
        && */
        ruc !== ""
      ) {
        this.setState({ loadingPaso: true });
        await this.props.crearCarrito({
          empresa: "AIGMETROPOLITANA",
          nomEmpresa: empresa,
          idEmpresa: ruc,
          nomPersona: solicitante,
          idPersona: cedula,
          idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
          sucursalSeleccionada: this.state.sucursalSeleccionada,
          codPais: "1",
          provincia: this.state.provinciaSelected,
          ciudad: this.state.ciudadSelected,
          mongoCarrito: this.state.idCarrito ? this.state.idCarrito : "",
          direccion: this.state.direccionSelected,
          ambiente:ambienteAplicacion,
          datosAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: this.state.sucursalSeleccionada,
            ambiente: ambienteAplicacion,
            emailAsesor:this.props.datosAsesor.correo?this.props.datosAsesor.correo:'',
            brokerRUC:this.props.datosAsesor.brokerRUC?this.props.datosAsesor.brokerRUC:'',
            brokerNombre:this.props.datosAsesor.brokerNombre?this.props.datosAsesor.brokerNombre:'',
            brokerCodigo:this.props.datosAsesor.brokerCodigo?this.props.datosAsesor.brokerCodigo:'',
          },
        });

        if (!this.props.datosCarritoAPTravelGroup.crearCarritoTravelGroupError) {
          this.setState({
            idCarrito: this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup
              .mongoCarrito
          });
        }
        this.props.history.push({
          pathname: "/servicios-cotizacion-accidente"
        });
      } else {
        console.log("NO VALIDO");
      }
    }    
  }

  async cambiarRucId(identificacion, tipo) {
    await this.props.consultarIdentificacion({
      empresa: "AIGMETROPOLITANA",
      identificador: identificacion,
      tipo: tipo
    });

    if (!this.props.datosIdentificacionAP.consultarIdentificacionAPhasError) {
      if (
        tipo === "ruc" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          empresa: this.props.datosIdentificacionAP.IdentificacionAP[0].nombre,
          hasEmpresaError: false,
          validate: true
        });
      } else if (
        tipo === "cedula" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          solicitante: this.props.datosIdentificacionAP.IdentificacionAP[0]
            .nombre,
          hasSolicitanteError: false,
          validate: true
        });
      }
    } else {
      if (tipo === "ruc") {
        this.setState({
          empresa: ""
        });
      } else if (tipo === "cedula") {
        this.setState({
          solicitante: ""
        });
      }
    }
  }

  async crearCarritoAp(datos) {
    console.log(datos);

    await this.props.crearCarrito(datos);

    if (!this.props.datosCarritoAPTravelGroup.crearCarritoTravelGroupError) {
      console.log(this.props.datosCarritoAPTravelGroup);

      this.setState({
        // idCarrito: this.props.datosCarritoAPTravelGroup.IdentificacionAP[0].nombre
      });
    } else {
    }
  }

  async componentDidMount() {
    window.scroll(0, 0);


    //obtener sucursales
    await this.props.fethSucursales();

    //se manda a listar las provincias
    await this.props.obtenerProvincias("AIGMETROPOLITANA", "travel");

    if (!this.props.listaProvinciasAP.obtenerProviciasAPError) {

      let arrayProvincias = [];   
      this.props.listaProvinciasAP.provinciasAP.map(p => {
        arrayProvincias.push({ value: p.provCodigoCore, label: p.label });
      }); 

      this.setState({
        arrayProvincias
      });
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("id");

    if (idCarrito !== undefined && idCarrito !== null && idCarrito !== "") {
      await this.props.recuperarCarrito({ idCarrito: idCarrito });


      const {
        sucursalSeleccionada
      } = this.props.datosRecuperarCarritoAP.recuperarCarritoAP.carDatosAsesor;

      const {
        provincia,
        ciudad,
        direccion
      } = this.props.datosRecuperarCarritoAP.recuperarCarritoAP.datosUbicacion;
      const {
        nomPersona,
        idPersona,
        nomEmpresa,
        idEmpresa,
        provinciaSelected,
        ciudadSelected,
      } = this.props.datosRecuperarCarritoAP.recuperarCarritoAP;

      this.setState({
        empresa: nomEmpresa,
        solicitante: nomPersona,
        ruc: idEmpresa,
        cedula: idPersona,
        idCarrito,
        hasEmpresaError: false,
        hasSolicitanteError: false,
        hasRucError: false,
        hasCedulaError: false,
        idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
        sucursalSeleccionada,
        provinciaSelected: provincia,
        hasProvinciaError: provincia !== "" ? false : true,
        ciudadSelected: ciudad,
        hasCiudadError: ciudad !== "" ? false : true,
        direccionSelected: direccion,
        hasDireccionError: direccion !== "" ? false : true
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.empresa !== this.state.empresa) {
      if (this.state.empresa !== "") {
        this.setState({ hasEmpresaError: false });
      } else {
        this.setState({ hasEmpresaError: true });
      }
    }

    if (prevState.solicitante !== this.state.solicitante) {
      if (this.state.solicitante !== "") {
        this.setState({ hasSolicitanteError: false });
      } else {
        this.setState({ hasSolicitanteError: true });
      }
    }

    if (prevState.provinciaSelected !== this.state.provinciaSelected) {
      if (this.state.provinciaSelected !== "") {
        //se manda a listar las provincias
        await this.props.obtenerCiudades({
          empresa: "AIGMETROPOLITANA",
          codProvincia: this.state.provinciaSelected.value,
          ramo: "travel"
        });

        console.log('lista ciudades',this.state.provinciaSelected.value,'-', this.props.listaCiudadesAP)

        if (
          this.props.listaCiudadesAP &&
          !this.props.listaCiudadesAP.obtenerCiudadesAPError &&
          this.props.listaCiudadesAP.ciudadesAP
        ) {
         
          this.setState({
            arrayCiudades: this.props.listaCiudadesAP.ciudadesAP.ciudades
          });
        }
      } else {
        this.setState({ hasProvinciaError: true });
      }
    }

    if (prevState.ciudadSelected !== this.state.ciudadSelected) {
      if (this.state.ciudadSelected !== "") {
        this.setState({ hasCiudadError: false });
      } else {
        this.setState({ hasCiudadError: true });
      }
    }
  }

  render() {
    
    let arraySucursales = [];   
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    }); 

    arraySucursales.unshift({ id: '', name: 'Seleccione una opción' })

    console.log(arraySucursales);
    let arrayProvincias = this.state.arrayProvincias;

    console.log('prov ',arrayProvincias);
    let arrayCiudades = this.state.arrayCiudades;
    const {
      validate,
      empresa,
      solicitante,
      ruc,
      cedula,
      loadingPaso,
      provinciaSelected,
      hasProvinciaError,
      hasCiudadError,
      hasSucursalError,
      ciudadSelected,
      direccionSelected,
      cargandoCiudades,
      sucursalSeleccionada
    } = this.state;
    let isLoading =
      this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading ===
      undefined
        ? false
        : this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading;

    return (
      <LoadingScreen
        loading={
          isLoading ||
          loadingPaso ||
          this.props.listaProvinciasAP.obtenerProvinciasLoading ||
          this.props.listaCiudadesAP.obtenerCiudadesLoading ||
          this.props.datosRecuperarCarritoAP.recuperarCarritoAPIsLoading ||
          this.props.duplicity.duplicidadPolizaLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        
        <Page
          title="Cotización Travel Guard"
          breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>

          <Row>
            <Col lg={7} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className="mb-5">
                    {" "}
                    Datos del Cliente
                  </h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">RUC </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          //tabIndex="1" // Optional.[String or Number].Default: none.
                          id="ruc" // Optional.[String].Default: "".  Input ID.
                          name="ruc" // Optional.[String].Default: "". Input name.
                          type="text" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                          value={ruc} // Optional.[String].Default: "".
                          placeholder="Ingrese el RUC ejm: 010493405001" // Optional.[String].Default: "".
                          onChange={(ruc, e) => {
                            this.setState({ ruc, hasRucError: false });

                            if (ruc.length === 13) {
                              this.cambiarRucId(ruc, "ruc");
                            }
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasRucError: res,
                              validate: !res
                            });
                          }}
                          onBlur={e => {
                            console.log(e);
                          }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            required: true,
                            maxlength: 13,
                            length: 13,
                            //type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha']
                            reg: /^[0-9]+(\.[0-9]+)?$/, //Optional.[Bool].Default: "" Custom regex.
                            msgOnError:
                              "El número de RUC debe tener 13 carácteres"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Nombre de la empresa{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                    
                        <Textarea
                           tabIndex="1"
                           type="input"
                           value={empresa}
                           name="empresa"
                           id="empresa"
                          classNameInput={"form-control"}
                          onChange={(empresa, e) => {
                            this.setState({
                              empresa: empresa.toUpperCase(),
                              hasEmpresaError: false
                            });
                          }}
                          
                          placeholder="Ingrese el nombre de la empresa"
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasEmpresaError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "empresa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = empresa;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                this.setState({ empresa: "" });
                                return "Por favor ingrese el nombre de la empresa.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Cédula del solicitante{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="input"
                          value={cedula}
                          name="cedula"
                          id="cedula"
                          classNameInput={"form-control"}
                          placeholder="Ingrese el número de cédula ejm: 010493405" // Optional.[String].Default: "".
                          onChange={(cedula, e) => {
                            this.setState({ cedula, hasCedulaError: false });

                            if (cedula.length === 10) {
                              this.cambiarRucId(cedula, "cedula");
                            }
                          }}
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasCedulaError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          //   onBlur={(e) => {console.log(e)}}
                          validationOption={{
                            name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false,
                            maxlength: 10,
                            length: 10,
                            type: "number",
                            msgOnError:
                              "El número de Cédula debe tener 10 carácteres"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">
                          Nombre del solicitante{" "}
                        </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="input"
                          value={solicitante}
                          name="solicitante"
                          id="solicitante"
                          classNameInput={"form-control"}
                          onChange={(solicitante, e) => {
                            this.setState({
                              solicitante: solicitante.toUpperCase(),
                              hasSolicitanteError: false
                            });
                          }}
                          placeholder="Ingrese el nombre del solicitante" // Optional.[String].Default: "".
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasSolicitanteError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "solicitante", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ\s]+$/,
                            regMsg:
                              "Por favor ingrese el nombre del solicitante",
                            msgOnError:
                              "El nombre del solicitante esta vacío o contiene simbolos" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>

                  <hr />

                  <h4 style={{ fontWeight: "bold" }} className="mb-5">
                    {" "}
                    Ubicación
                  </h4>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Provincia </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          value={provinciaSelected}
                          components={makeAnimated()}
                          onChange={(provincia, e) => {
                            this.setState({
                              provinciaSelected: provincia,
                              ciudadSelected: "",
                              hasProvinciaError: false
                            });
                            //  this.onChangeProvincia(provincia.value.toString())
                          }}
                          options={arrayProvincias}
                          isSearchable={true}
                          placeholder={"Seleccione una provincia"}
                          isMulti={false}
                        />
                        {hasProvinciaError && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una provincia
                          </span>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Ciudad </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          value={ciudadSelected}
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            this.setState({
                              ciudadSelected: ciudad,
                              hasCiudadError: false
                            });
                          }}
                          options={arrayCiudades}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />

                        {hasCiudadError && (
                          <span style={{ color: "red", fontSize: "1rem" }}>
                            Por favor seleccione una ciudad
                          </span>
                        )}
                      </Col>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
                      <h5>
                        <Label className="bold-font-label">Dirección </Label>
                      </h5>
                    </Col>
                    <Col lg={7} md={7} sm={12} xs={12}>
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textarea
                          tabIndex="1"
                          type="input"
                          value={direccionSelected}
                          name="direccion"
                          id="direccion"
                          classNameInput={"form-control"}
                          onChange={(direccion, e) => {
                            this.setState({
                              direccionSelected: direccion.toUpperCase(),
                              hasDireccionError: false
                            });
                          }}
                          placeholder="Ingrese la dirección" // Optional.[String].Default: "".
                          validate={validate}
                          validationCallback={res => {
                            this.setState({
                              hasDireccionError: res,
                              validate: !res
                            });
                          }} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                            //console.log("BLUUUR");
                          }}
                          validationOption={{
                            name: "Dirección", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = direccionSelected;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                this.setState({ direccionSelected: "" });
                                return "Debe ingresar una dirección.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>


                  {this.props.datosUsuarios.usu_tipo_usuario !== 'cliente' && 

                          <>

<hr />

<h4 style={{ fontWeight: "bold" }} className="mb-5">
  {" "}
  SUCURSAL DE EMISIÓN
</h4>

<Row className="mb-3">
  <Col lg={4} md={4} sm={12} xs={12} className="ml-3">
    <h5>
      <Label className="bold-font-label">Sucursal </Label>
    </h5>
  </Col>
  <Col lg={7} md={7} sm={12} xs={12}>
    <Col lg={8} md={8} sm={12} xs={12}>
          <Select1
            tabIndex="6" // Optional.[String or Number].Default: none.
            id={"sucursalSeleccionada"} // Optional.[String].Default: "". Input ID.
            name={"sucursalSeleccionada"} // Optional.[String].Default: "". Input name.
            value={sucursalSeleccionada} // Optional.[String].Default: "".
            optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
            onChange={(selec, e) => {
              //console.log(selec);
              this.setState({ sucursalSeleccionada: selec });
            }}
            validate={validate}
            validationCallback={res =>
              //console.log(res) 
              this.setState({
                hasSucursalError: res,
                validate: !res
              })
            }
            // Optional.[Func].Default: () => {}. Will return the value.
            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
            validationOption={{
              name: "sucursalSeleccionada", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
              msgOnError: "Por favor seleccione una sucursal"
            }}
          />
       </Col>
  </Col>
</Row>


                          </>
                  

                 }

              

                  <Row>
                    <div className="div-align-rigth">
                      <Button
                        className="btn btn-primary"
                        onClick={this.validateForm}
                        style={{ display: "block", margin: "auto" }}
                      >
                        <i
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        />{" "}
                        {"CONTINUAR"}
                      </Button>
                    </div>
                  </Row>
                  {/* Mensaje de error*/}
                  <div style={{ marginTop:'2rem'}}>
                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg',  this.props.duplicity)}
                    {this.props.duplicity.isDuplicatePoliza
                    ?
                    <Alert color="danger">
                        <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                    </Alert>
                    :
                    null
                    }
                    {this.props.duplicity.duplicidadPolizaError &&
                      <Alert color="danger" >
                        <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                      </Alert>
                    }
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosIdentificacionAP: state.datosIdentificacionAP,
  datosCarritoAPTravelGroup: state.datosCarritoAPTravelGroup,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosRecuperarCarritoAP: state.datosRecuperarCarritoAP,
  listaProvinciasAP: state.listaProvinciasAP,
  listaCiudadesAP: state.listaCiudadesAP,
  sucursales: state.datosSucursales.DataSucursales,
  datosAsesor: state.datosUsuarios.dataUsuario,
  duplicity: state.datosDuplicidadPolizas,
});

const mapDispatchToProps = dispatch => {
  return {
    consultarIdentificacion: datos =>
      dispatch(fetchConsultarIdentificacionAP(datos)),
    crearCarrito: datos => dispatch(fetchCrearCarritoAP(datos)),
    recuperarCarrito: datos => dispatch(fetchRecuperarCarritoAP(datos)),
    obtenerProvincias: (empresa, ramo) =>
      dispatch(fetchListarProvinciasAP(empresa, ramo)),
    obtenerCiudades: datos => dispatch(fetchListarCiudadesAP(datos)),
    fethSucursales: () => dispatch(sucursalesFetch()),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAPersonal)
);
